// import React, { useState, useEffect, useContext, useRef } from "react";
// import {
//   Input,
//   Form,
//   Row,
//   Col,
//   DatePicker,
//   Typography,
//   Select,
//   Table,
//   InputNumber,
//   message,
//   Button,
//   Popconfirm,
// } from "antd";

// import moment from "moment";
// import "./form.less";
// import { platformApi } from "../../../../../api";
// import { LeftOutlined } from "@ant-design/icons";
// import WrappedVehiclePurchaseForm from "./VehicleDetails";
// import { useBranch } from "../../../../../ContextAPI/branch";
// import { useHistory } from "react-router-dom";
// const { Item } = Form;

// const { Text, Title } = Typography;

// const VPIModal = (props) => {
//   const history = useHistory();
//   const { form, open, close, editData, editable: isEditable, modify } = props;
//   const { selectBranch } = useBranch();
//   const [branch, setBranch] = useState({ id: "", name: "" });
//   const [loading, setLoading] = useState(false);
//   const [editable, setEditable] = useState(isEditable);
//   const [openVehicle, setOpenVehicle] = useState(false);
//   const [invoiceDate, setInvoiceDate] = useState();
//   const [purchaseInvoiceNo, setPurchaseInvoice] = useState(props.id);
//   const [challan, setChallan] = useState({});
//   const [challanData, setChallanData] = useState({
//     date: moment(new Date()),
//     challanDate: moment(Date.now()),
//     id: null,
//   });
//   const [vehicle, setVehicle] = useState([]);
//   const [vehicleDetail, setVehicleDetail] = useState([]);
//   const [deletedVehicle, setDeletedVehicle] = useState([]);
//   const [quantity, setQuantity] = useState();
//   const [amount, setAmt] = useState();
//   const [displayIGST, setDisplayIGST] = useState(false);
//   const [editChallanNo, setEditChallan] = useState();
//   const [dataSource, setDataSource] = useState([]);
//   const [tableData, setTable] = useState([]);
//   const [invoiceAmount, setInvoiceAmount] = useState([]);
//   const [selected, setSelected] = useState(-1);
//   const [suppliers, setSuppliers] = useState([]);
//   const [invoiceId, setInvoiceId] = useState();
//   const { getFieldDecorator, setFieldsValue, getFieldValue } = form;
//   const [supplierInvoiceNoError, setSupplierInvoiceNoError] = useState("");
//   const [selectedVehicleIndex, setSelectedVehicleIndex] = useState(null);
//   const [editVehicleData, setEditVehicleData] = useState(null);
//   const [latestPrices, setLatestPrices] = useState({});
//   const isInitialLoad = useRef(false);


//   useEffect(() => {
//     const fetchLatestPrices = async () => {
//       try {
//         const prices = {};
//         for (const item of vehicleDetail) {
//           const vehicleId = item?.vehicle?.id;
//           if (!vehicleId) continue;

//           const res = await platformApi.get(`/api/vehiclePrice/latest/${vehicleId}`);
//           if (res.data.code === 200 && res.data.response?.data) {

//             prices[vehicleId] = res.data.response.data?.[0]?.showroomPrice; // or any field like insurance1plus5ZD, etc.
//           }
//         }
//         setLatestPrices(prices);
//       } catch (err) {
//         console.error("Error fetching latest prices:", err);
//       }
//     };

//     if (vehicleDetail.length > 0) {
//       fetchLatestPrices();
//     }
//   }, [vehicleDetail]);


//   useEffect(() => {
//     platformApi.get("/api/vehicleMaster").then((result) => {
//       let { data } = result;
//       if (data.code === 200) {
//         let results = [];
//         data.response.data.map((obj) => {
//           if (obj.vehicleStatus === "AVAILABLE") results.push(obj);
//         });
//         // setVehicle(data.response.data);
//         setVehicle(results);
//       }
//     });
//   }, []);

//   useEffect(() => {
//     if (editData?.id && editData.purchaseChallan) {
//       const purchaseChallan = editData.purchaseChallan;
//       setInvoiceId(editData.id);
//       setQuantity(editData.quantity);
//       setAmt(editData.amount);
//       setVehicleDetail((prevData) => [
//         ...prevData,
//         ...purchaseChallan.vehicleDetail,
//       ]);
//       form.setFieldsValue({
//         supplier: purchaseChallan.supplier.id,
//         invoiceDate: moment(editData.invoiceDate),
//         invoiceNo: editData.invoiceNo,
//         others: editData.others,
//         roundOff: editData.roundOff,
//         netAmount: editData.netAmount,
//         grossTotal: editData.grossTotal,
//         supplierInvoiceNo: purchaseChallan.supplierChallanNo,
//       });
//       setChallanData({
//         id: purchaseChallan.id,
//         challanNo: purchaseChallan.challanNo,
//         supplierChallanNo: purchaseChallan.supplierChallanNo,
//         supplier: purchaseChallan.supplier.id,
//         location: purchaseChallan.branch.id,
//         date:
//           purchaseChallan.date === null
//             ? moment(Date.now())
//             : moment(purchaseChallan.date),
//         challanDate: moment(purchaseChallan.challanDate),
//       });
//       setPurchaseInvoice(editData.invoiceNo);
//       setEditChallan(purchaseChallan.id);
//       setInvoiceDate(editData.invoiceDate);
//       isInitialLoad.current = true;
//     } else {
//       setFieldsValue({
//         invoiceDate: moment(new Date()),
//       });
//       platformApi.get("api/supplier").then((result) => {
//         let { data } = result;
//         if (data.code === 200) {
//           let { response } = data;
//           if (response.code === 200) {
//             let supplier = response.data.filter(
//               (obj) =>
//                 obj.supplierType.includes("Vehicles") && obj.status === "ACTIVE"
//             );
//             setSuppliers(supplier);
//             if (!data) setFieldsValue({ supplier: supplier[0].id });
//           }
//         }
//       });
//     }
//     if (editData?.purchaseChallan?.branch) {
//       setBranch(editData.purchaseChallan.branch);
//     } else {
//       setBranch(selectBranch[0]);
//     }
//   }, [editData]);



//   useEffect(() => {
//     if (open === false) {
//       setDataSource([]);
//       setInvoiceAmount([]);
//     }
//   }, [open]);

//   useEffect(() => {
//     if (open) {
//       form.setFieldsValue({
//         invoiceDate: moment(new Date()),
//       });
//       setTable(props.tableData);
//       platformApi.get("/api/user/currentUser").then((result) => {
//         let { data } = result;
//         if (data.code === 200) {
//           let { response } = data;
//           if (response.code === 200) {
//             setBranch(response.data.profile.branch[0]);
//           }
//         }
//       });

//       platformApi.get("/api/purchaseChallan/").then((res) => {
//         let result = [];
//         let { data } = res;
//         if (data.code === 200) {
//           let { response } = data;
//           response.data.map((resp) => {
//             if (
//               props.tableData.findIndex(
//                 (obj) => obj.purchaseChallan.id === resp.id
//               ) === -1
//             ) {
//               let obj = {
//                 id: resp.id,
//                 name: resp.challanNo,
//                 SupplierinvoiceNo: resp.supplierChallanNo,
//                 supplier: resp.supplier,
//                 location: resp.branch,
//                 vehicle: resp.vehicleDetail,
//               };
//               result.push(obj);
//             }
//           });
//           setChallan(result);
//         } else {
//           message.error("Couldn't fetch id");
//         }
//       });

//       platformApi.get("/api/vehicleMaster").then((result) => {
//         let { data } = result;
//         if (data.code === 200) {
//           setVehicle(data.response.data);
//         }
//       });

//       form.setFieldsValue({ invoiceNo: props.id });
//     }
//   }, [open]);

//   const handlePriceChange = (value, chassis) => {
//     let grossTotal = 0;
//     const data = [...dataSource];
//     for (const index in data) {
//       if (data[index].chassisNo === chassis) {
//         data[index]["amount"] = roundOf(
//           data[index]["quantity"] * parseFloat(value)
//         );
//       }
//       grossTotal += data[index]["amount"];
//     }
//     setDataSource(data);
//     setAmt(grossTotal);
//     // GST calculation (exclusive)
//     const cess = form.getFieldValue("cess") || 0;
//     const others = form.getFieldValue("others") || 0;
//     const gstSummary = calculateGSTSummary(data, cess, others);
//     form.setFieldsValue({
//       grossTotal: gstSummary.grossTotal,
//       cgst: gstSummary.totalCGST.toFixed(2),
//       sgst: gstSummary.totalSGST.toFixed(2),
//       netAmount: gstSummary.roundedNetAmount,
//       roundOff: gstSummary.roundOff,
//     });
//   };

//   const deleteVehicleData = (record) => {
//     const chassis = record.chassisNo;
//     const updatedDataSource = [];
//     const deletedVehicleDetail = [];
//     const updatedVehicleDetail = [];
//     for (const item of dataSource) {
//       if (item.chassisNo !== chassis) {
//         updatedDataSource.push(item);
//       }
//     }

//     for (const item of vehicleDetail) {
//       if (item.chassisNo === chassis) {
//         deletedVehicleDetail.push(item);
//       } else {
//         updatedVehicleDetail.push(item);
//       }
//     }

//     setDataSource(updatedDataSource);
//     setDeletedVehicle(deletedVehicleDetail);
//     setVehicleDetail(updatedVehicleDetail);
//   };

//   const handleModifyVehicle = (record, index) => {
//     setSelectedVehicleIndex(index);
//     setEditVehicleData(record);
//     setOpenVehicle(true);
//   };

//   const handleSaveEditedVehicle = (editedVehicle) => {
//     // Replace the vehicle at selectedVehicleIndex in vehicleDetail and dataSource
//     const updatedVehicleDetail = [...vehicleDetail];
//     const updatedDataSource = [...dataSource];
//     updatedVehicleDetail[selectedVehicleIndex] = {
//       ...updatedVehicleDetail[selectedVehicleIndex],
//       ...editedVehicle,
//     };
//     updatedDataSource[selectedVehicleIndex] = {
//       ...updatedDataSource[selectedVehicleIndex],
//       ...editedVehicle,
//     };
//     setVehicleDetail(updatedVehicleDetail);
//     setDataSource(updatedDataSource);
//     setOpenVehicle(false);
//     setSelectedVehicleIndex(null);
//     setEditVehicleData(null);
//   };

//   const column = [
//     {
//       title: "S.NO",
//       key: "index",
//       render: (text, record, index) => <span>{index + 1}</span>,
//     },
//     {
//       title: "Model Code",
//       dataIndex: "modelCode",
//       key: "modelCode",
//       render: (record) => <span>{record}</span>
//     },
//     {
//       title: "Model Name",
//       dataIndex: "modelName",
//       key: "modelName",
//       width: 150,
//       render: (record) => <span>{record}</span>
//     },
//     {
//       title: "Vehicle Color",
//       dataIndex: "modelColor",
//       key: "modelColor",
//       render: (record) => <span>{record}</span>,
//     },
//     {
//       title: "Chassis Number",
//       dataIndex: "chassisNo",
//       key: "chassisNo",
//       width: 150,
//       render: (record) => <span>{record}</span>,
//     },
//     {
//       title: "Engine Number",
//       dataIndex: "engineNo",
//       key: "engineNo",
//       render: (record) => <span>{record}</span>,
//     },
//     {
//       title: "GST",
//       dataIndex: "igst",
//       key: "igst",
//       render: (record) => <span>{record}</span>,
//     },
//     {
//       title: "Price",
//       key: "price",
//       width: 200,
//       render: (record) => (
//         <Input
//           min={0}
//           type="number"
//           step="0.01"
//           addonBefore="&#8377;"
//           key="price"
//           disabled={!editable}
//           onChange={(event) => {
//             handlePriceChange(
//               parseFloat(event.target.value) || 0,
//               record.chassisNo
//             );
//           }}
//           onWheel={(event) => event.currentTarget.blur()}
//           placeholder={
//             latestPrices[record.vehicle?.id] || record.priceZ?.price || "-"
//           }
//         />
//       ),
//     },
//     {
//       title: "Action",
//       key: "modelCode",
//       width: 130,
//       render: (record, row, index) => (
//         <div style={{ display: "flex", gap: 8 }}>
//           <span
//             className="linkylink"
//             style={{ marginRight: 8, color: "#1890ff", cursor: "pointer" }}
//             onClick={() => handleModifyVehicle(record, index)}
//           >
//             Modify
//           </span>
//           <Popconfirm
//             title="Do you want to delete SSI?"
//             okText="Yes"
//             cancelText="No"
//             onCancel={(event) => {
//               event.stopPropagation();
//             }}
//             disabled={!editable}
//             onConfirm={(event) => {
//               event.stopPropagation();
//               deleteVehicleData(record);
//             }}
//           >
//             <span
//               className="linkylink"
//               onClick={(event) => event.stopPropagation()}
//             >
//               Delete
//             </span>
//           </Popconfirm>
//         </div>
//       ),
//     },
//   ];

//   const roundOf = (number) => {
//     if (number == null) return number;
//     const roundedNumber = parseFloat(number).toFixed(2);
//     return parseFloat(roundedNumber);
//   };

//   const handleModify = () => {
//     setEditable(true);
//   };

//   const handleSubmit = () => {
//     if (vehicleDetail.length < 1)
//       return message.error("Select at least one vehicle");
//     form.validateFields((validationError) => {
//       if (validationError === null) {
//         setLoading(true);
//         const invoiceNo = purchaseInvoiceNo || props.id;
//         const invoiceDate = form.getFieldValue("invoiceDate");
//         const purchaseChallan =
//           editChallanNo || form.getFieldValue("challanNo");
//         const grossTotal = form.getFieldValue("grossTotal");
//         const others = parseInt(form.getFieldValue("others"));
//         const netAmount = form.getFieldValue("netAmount");
//         const roundOff = form.getFieldValue("roundOff");
//         const supplier = form.getFieldValue("supplier");
//         const supplierInvoiceNo = form.getFieldValue("supplierInvoiceNo");
//         let results = [];
//         for (const index in dataSource) {
//           vehicleDetail[index].invoiceAmount = dataSource[index].amount;
//           let newObj = {
//             id: dataSource[index].priceZ.vehicleId,
//             amount: dataSource[index].amount,
//           };
//           results.push(newObj);
//         }
//         setInvoiceAmount(results);

//         let invoiceAmount = results;
//         const vpi = {
//           id: invoiceId,
//           invoiceNo,
//           invoiceDate,
//           purchaseChallan,
//           grossTotal,
//           others,
//           quantity,
//           amount,
//           netAmount: Number(netAmount),
//           roundOff: Number(roundOff),
//           invoiceAmount,
//           branch: branch.id,
//           vehicleDetail,
//           deletedVehicle,
//           challan,
//           challanData,
//           supplier,
//           supplierInvoiceNo,
//         };
//         props.emitData(vpi);
//         setLoading(false);
//         // dataSource.length = 0; // Removed direct state mutation
//         props.close();
//         // clearFields();
//       }
//     });
//   };

//   const handleCancel = () => {
//     form.resetFields();
//     history.push("/autoadmin/vehicle_purchase_invoice");
//   };

//   const emitVehicleData = (data) => {
//     // setChallan(data)
//     handleChallanChange(data);
//   };

//   const clearFields = () => {
//     form.resetFields();
//   };

//   const onChange = (date, dateString) => {
//     setInvoiceDate(dateString);
//   };

//   const handleChallanChange = (selectedVehicles) => {
//     const updatedVehicles = selectedVehicles;
//     for (const index in updatedVehicles) {
//       updatedVehicles[index].invoiceAmount =
//         vehicle[
//           vehicle.findIndex(
//             (obj) => obj.modelCode === updatedVehicles[index].vehicle.modelCode
//           )
//         ]?.price[0]?.showroomPrice || null;
//     }
//     setVehicleDetail((prevData) => [...prevData, ...updatedVehicles]);
//   };

//   const othersChange = (valuez) => {
//     if (valuez === "-") return;
//     const value = Number(valuez) || 0;
//     const cess = form.getFieldValue("cess") || 0;
//     const gstSummary = calculateGSTSummary(dataSource, cess, value);
//     form.setFieldsValue({
//       netAmount: gstSummary.roundedNetAmount,
//       roundOff: gstSummary.roundOff,
//     });
//   };

//   const roundOffChange = (e) => {
//     const valuez = e.target.value;
//     if (valuez === "-") return;
//     const value = parseFloat(valuez) || 0;
//     const others = form.getFieldValue("others") || 0;
//     const cess = form.getFieldValue("cess") || 0;
//     const gstSummary = calculateGSTSummary(dataSource, cess, others);
//     const netAmount =
//       gstSummary.grossTotal +
//       gstSummary.totalGST +
//       (parseFloat(cess) || 0) +
//       (parseFloat(others) || 0) +
//       value;
//     form.setFieldsValue({
//       netAmount: netAmount.toFixed(2),
//     });
//   };

//   // GST calculation (exclusive)
//   function calculateGSTSummary(dataSource, cess = 0, others = 0) {
//     const gstGroups = {};
//     let totalCGST = 0;
//     let totalSGST = 0;
//     let totalIGST = 0;
//     let grossTotal = 0;

//     dataSource.forEach((item) => {
//       const gstPercent = parseFloat(item.igst) || 0;
//       const price = parseFloat(item.amount) || 0;
//       grossTotal += price;
//       if (!gstPercent || !price) return;
//       // Exclusive GST calculation
//       const cgstAmountItem = (price * (gstPercent / 2)) / 100;
//       const sgstAmountItem = (price * (gstPercent / 2)) / 100;
//       const igstAmountItem = (price * gstPercent) / 100;
//       totalCGST += cgstAmountItem;
//       totalSGST += sgstAmountItem;
//       totalIGST += igstAmountItem;
//       if (!gstGroups[gstPercent]) {
//         gstGroups[gstPercent] = {
//           gstPercent,
//           cgstPercent: gstPercent / 2,
//           sgstPercent: gstPercent / 2,
//           taxableValue: 0,
//           cgstAmount: 0,
//           sgstAmount: 0,
//           igstAmount: 0,
//         };
//       }
//       gstGroups[gstPercent].taxableValue += price;
//       gstGroups[gstPercent].cgstAmount += cgstAmountItem;
//       gstGroups[gstPercent].sgstAmount += sgstAmountItem;
//       gstGroups[gstPercent].igstAmount += igstAmountItem;
//     });

//     grossTotal = parseFloat(grossTotal.toFixed(2));
//     const totalGST = totalCGST + totalSGST; // or totalIGST if IGST is used
//     let netAmount =
//       grossTotal +
//       totalGST +
//       (parseFloat(cess) || 0) +
//       (parseFloat(others) || 0);
//     let roundedNetAmount = Math.ceil(netAmount);
//     let roundOff = parseFloat((roundedNetAmount - netAmount).toFixed(2));

//     return {
//       gstGroups,
//       totalCGST,
//       totalSGST,
//       totalIGST,
//       grossTotal,
//       totalGST,
//       netAmount,
//       roundedNetAmount,
//       roundOff,
//     };
//   }

//   // Call GST calculation on vehicle/vehicleDetail change
//   useEffect(() => {
//     if (vehicle[0] && vehicleDetail[0]) {
//       let results = [];
//       let index = {};
//       vehicleDetail.forEach((point) => {
//         let key = "" + point.vehicle.modelCode + "||" + point.vehicle.modelName;
//         let newEntry = {
//           modelCode: point.vehicle.modelCode,
//           modelName: point.vehicle.modelName,
//           modelColor: point.color?.color,
//           hsnCode: point.vehicle?.hsn?.code,
//           chassisNo: point.chassisNo,
//           engineNo: point.engineNo,
//           igst: point.vehicle?.hsn?.igst,
//           quantity: 1,
//           amount: 0,
//           price: point.invoiceAmount,
//           priceZ: {
//             price: point.invoiceAmount,
//             code: point.vehicle.modelCode,
//             challanId: editData?.purchaseChallan?.id || "",
//             vehicleId: point.id,
//           },
//           manufacturer: point.vehicle?.manufacturer,
//           batteryNo: point.batteryNo,
//           warrantyBookNo: point.warrantyBookNo,
//           keyNo: point.keyNo,
//           vehicle: point.vehicle,
//           manMonthYear: point.manMonthYear,
//           color: point.color
//         };
//         index[key] = newEntry;
//         results.push(newEntry);
//       });
//       results.forEach((obj) => {
//         obj.price /= obj.quantity;
//         obj.amount = obj.price * obj.quantity;
//       });
//       setDataSource(results);
//       setQuantity(results.reduce((sum, obj) => sum + obj.quantity, 0));
//       setAmt(results.reduce((sum, obj) => sum + obj.amount, 0));
//       if (!isInitialLoad.current) {
//         // GST calculation (exclusive)
//         const cess = form.getFieldValue("cess") || 0;
//         const others = form.getFieldValue("others") || 0;
//         const gstSummary = calculateGSTSummary(results, cess, others);
//         form.setFieldsValue({
//           grossTotal: gstSummary.grossTotal,
//           cgst: gstSummary.totalCGST.toFixed(2),
//           sgst: gstSummary.totalSGST.toFixed(2),
//           netAmount: gstSummary.roundedNetAmount,
//           roundOff: gstSummary.roundOff,
//         });
//       }
//       isInitialLoad.current = false;
//     }
//   }, [vehicle, vehicleDetail]);

//   const renderGSTSummaryForm = () => {
//     const gstSummary = calculateGSTSummary(dataSource);
//     return (
//       <div
//         className="gst-table"
//         style={{
//           border: "1px solid #222",
//           borderRadius: 4,
//           padding: 8,
//           maxWidth: 320,
//           margin: "20px 0",
//           background: "#f8fafc",
//         }}
//       >
//         <div
//           style={{
//             textAlign: "center",
//             fontWeight: 600,
//             borderBottom: "1px solid #222",
//             marginBottom: 8,
//           }}
//         >
//           GST Data
//         </div>
//         {Object.values(gstSummary.gstGroups).map((g, i) => (
//           <React.Fragment key={i}>
//             <Form.Item
//               className="form-element"
//               style={{ marginBottom: 4, display: "flex", alignItems: "center" }}
//               label={<span style={{ minWidth: 60 }}>CGST:</span>}
//             >
//               <span style={{ marginRight: 8 }}>{g.cgstPercent}%</span>
//               <Input
//                 style={{ width: 120 }}
//                 disabled
//                 value={g.cgstAmount.toFixed(2)}
//               />
//             </Form.Item>
//             <Form.Item
//               className="form-element"
//               style={{ marginBottom: 8, display: "flex", alignItems: "center" }}
//               label={<span style={{ minWidth: 60 }}>SGST:</span>}
//             >
//               <span style={{ marginRight: 8 }}>{g.sgstPercent}%</span>
//               <Input
//                 style={{ width: 120 }}
//                 disabled
//                 value={g.sgstAmount.toFixed(2)}
//               />
//             </Form.Item>
//           </React.Fragment>
//         ))}
//       </div>
//     );
//   };

//   // Prepare branch options for the dropdown
//   let branchOptions = selectBranch ? [...selectBranch] : [];
//   if (
//     editData?.purchaseChallan?.branch &&
//     !branchOptions.some((b) => b.id === editData.purchaseChallan.branch.id)
//   ) {
//     branchOptions = [editData.purchaseChallan.branch, ...branchOptions];
//   }

//   return (
//     <Form>
//       <Row type="flex" justify="space-between">
//         <Row type="flex" justify="space-between">
//           <Col span={10}>
//             <Item
//               label={<Text> Internal VPI Number.</Text>}
//               colon={false}
//               required={false}
//             >
//               {getFieldDecorator("invoiceNo", {
//                 rules: [
//                   {
//                     // required: true,
//                     message: "Enter Internal Vehicle Purchase Invoice",
//                   },
//                 ],
//               })(
//                 <Input
//                   disabled={true}
//                   placeholder={props.id}
//                   // value={props.id}
//                   style={{ width: "27.5rem" }}
//                 />
//               )}
//             </Item>
//           </Col>
//           <Col span={11}></Col>
//         </Row>
//         <Col span={10}>
//           <Item label="Invoice Date" colon={false}>
//             {getFieldDecorator("invoiceDate", {
//               rules: [{ required: true, message: "Enter Invoice Date" }],
//             })(
//               <DatePicker
//                 disabled={!editable}
//                 allowClear={true}
//                 disabledDate={(moment) => moment._d > Date.now()}
//                 format="DD-MMM-YYYY"
//                 style={{ width: "100%" }}
//               />
//             )}
//           </Item>
//         </Col>
//       </Row>
//       <Row type="flex" justify="space-between">
//         <Col span={10}>
//           <Form.Item
//             className="purchase-form-element"
//             label="Location"
//             name="branch"
//             required
//           >
//             <Select
//               dropdownStyle={{
//                 overflowY: "auto",
//                 overflowX: "hidden",
//               }}
//               value={branch.id}
//               onChange={(branchId) => {
//                 const selectedBranch = branchOptions.find(
//                   (b) => b.id === branchId
//                 );
//                 setBranch(selectedBranch || { id: branchId, name: branchId });
//               }}
//               showAction={["click", "focus"]}
//               showSearch
//               placeholder="Branch"
//               filterOption={null}
//             >
//               {branchOptions.map((eachBranch) => (
//                 <Select.Option key={eachBranch.id} value={eachBranch.id}>
//                   {eachBranch.name}
//                 </Select.Option>
//               ))}
//             </Select>
//           </Form.Item>
//         </Col>
//       </Row>
//       <Row type="flex" justify="space-between">
//         <Col span={10}>
//           <Item colon={false} label="Supplier">
//             {getFieldDecorator("supplier", {
//               rules: [{ required: true, message: "Select Supplier" }],
//             })(
//               <Select
//                 disabled={!editable}
//                 placeholder="Select the supplier"
//                 showSearch
//                 optionFilterProp="children"
//                 filterOption={(input, option) =>
//                   option.props.children.toLowerCase().includes(input.toLowerCase())
//                 }
//               >
//                 {suppliers.map((supplier) => (
//                   <Select.Option key={supplier.id} value={supplier.id}>
//                     {supplier.name}
//                   </Select.Option>
//                 ))}
//               </Select>
//             )}
//           </Item>
//         </Col>
//         <Col span={10}>
//           <Item
//             label={<Text>Supplier Invoice Number.</Text>}
//             colon={false}
//             required={false}
//           >
//             {getFieldDecorator("supplierInvoiceNo", {
//               rules: [
//                 {
//                   required: true,
//                   message: "Enter Supplier Invoice Number.",
//                 },
//                 {
//                   validator: async (rule, value, callback) => {
//                     const supplierId = form.getFieldValue("supplier");
//                     if (!value || !supplierId) {
//                       callback();
//                       return;
//                     }
//                     const res = await platformApi.post(
//                       "/api/purchaseInvoice/checkDuplicateInvoiceNo",
//                       { invoiceNo: value, supplierId }
//                     );
//                     let { data } = res;
//                     if (editData?.invoiceNo) {
//                       if (
//                         data.duplicate &&
//                         data?.data?.invoiceNo != editData.invoiceNo
//                       ) {
//                         callback("Invoice Number already exists");
//                       } else {
//                         callback();
//                       }
//                     } else {
//                       if (data.duplicate) {
//                         callback("Invoice Number already exists");
//                       } else {
//                         callback();
//                       }
//                     }
//                   },
//                 },
//               ],
//             })(
//               <Input
//                 disabled={!editable || !form.getFieldValue("supplier")}
//                 placeholder="Supplier Invoice Number"
//                 onKeyUp={(e) => {
//                   // Allow alphanumeric, hyphens, dots, forward slashes, and spaces
//                   const value = e.target.value.replace(/[^a-zA-Z0-9\-./\s]/g, '');
//                   form.setFieldsValue({
//                     supplierInvoiceNo: value,
//                   });
//                 }}
//                 onInput={(event) => {
//                   // Filter out special characters in real-time
//                   const rawValue = event.target.value;
//                   const filteredValue = rawValue.replace(/[^a-zA-Z0-9\-./\s]/g, '');
//                   if (filteredValue !== rawValue) {
//                     event.target.value = filteredValue;
//                     form.setFieldsValue({
//                       supplierInvoiceNo: filteredValue,
//                     });
//                   }
//                 }}
//               />
//             )}
//           </Item>
//         </Col>
//       </Row>
//       <div>
//         <strong>Add vehicle details</strong>
//         <Button
//           style={{ margin: "0 2rem" }}
//           type="primary"
//           onClick={() => {
//             setOpenVehicle(true);
//             setEditable(editable);
//           }}
//           disabled={!editable}
//         >
//           Add
//         </Button>
//       </div>
//       <br />
//       <Table
//         rowKey={(record) => record.id}
//         pagination={false}
//         columns={column}
//         style={{ cursor: "pointer" }}
//         tableLayout="fixed"
//         dataSource={dataSource}
//       />
//       <Row type="flex" justify="space-between" align="middle">
//         <Col span={6} style={{ display: "flex", alignItems: "center" }}>
//           <Item label={<Text>Gross Total</Text>} colon={false} required={false}>
//             {getFieldDecorator("grossTotal")(
//               <Input
//                 addonBefore="&#8377;"
//                 disabled={true}
//                 placeholder="Gross Total"
//               />
//             )}
//           </Item>
//         </Col>
//         <Col
//           span={12}
//           style={{
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//           }}
//         >
//           <div
//             style={{ display: "flex", justifyContent: "center", width: "100%" }}
//           >
//             {renderGSTSummaryForm()}
//           </div>
//         </Col>
//         <Col
//           span={6}
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "flex-end",
//           }}
//         >
//           <Item label={<Text>Others</Text>} colon={false} required={false}>
//             {getFieldDecorator("others")(
//               <InputNumber
//                 disabled={!editable}
//                 placeholder="Others"
//                 onChange={othersChange}
//               />
//             )}
//           </Item>
//         </Col>
//       </Row>
//       <Row type="flex" justify="space-between">

//         <Col span={4}>
//           <Item label={<Text>Cess</Text>} colon={false} required={false}>
//             {getFieldDecorator(
//               "cess"

//             )(<Input disabled={true} placeholder="Cess" />)}
//           </Item>
//         </Col>
//         <Col span={4}>
//           <Item label={<Text>Round Off</Text>} colon={false} required={false}>
//             {getFieldDecorator(
//               "roundOff"

//             )(
//               <Input
//                 addonBefore="&#8377;"
//                 // disabled={true}
//                 placeholder="Round Off"
//                 onChange={roundOffChange}
//               />
//             )}
//           </Item>
//         </Col>
//         <Col span={4}>
//           <Item label={<Text>Net Amount</Text>} colon={false} required={false}>
//             {getFieldDecorator(
//               "netAmount"

//             )(
//               <Input
//                 addonBefore="&#8377;"
//                 disabled={true}
//                 placeholder="Net Amount"
//               />
//             )}
//           </Item>
//         </Col>
//       </Row>
//       <div style={{ float: "right" }}>
//         <Button
//           style={{ marginRight: "1rem" }}
//           size="large"
//           onClick={() => handleCancel()}
//         >
//           Cancel
//         </Button>
//         <Button
//           type="primary"
//           size="large"
//           onClick={editable ? () => handleSubmit() : () => handleModify()}
//         >
//           {editable ? "Save" : "Modify"}
//         </Button>
//       </div>
//       {openVehicle && (
//         <WrappedVehiclePurchaseForm
//           open={openVehicle}
//           close={() => {
//             setOpenVehicle(false);
//             setSelectedVehicleIndex(null);
//             setEditVehicleData(null);
//             setSelected(null);
//           }}
//           emitData={
//             selectedVehicleIndex !== null
//               ? (data) => handleSaveEditedVehicle(data[0])
//               : emitVehicleData
//           }
//           data={editVehicleData}
//         />
//       )}
//     </Form>
//   );
// };

// const VehiclePurchaseInvoiceForm = Form.create({ name: "normal_login" })(
//   VPIModal
// );

// export default VehiclePurchaseInvoiceForm;
import React, { useState, useEffect, useContext } from "react";
import {
  Input,
  Form,
  Row,
  Col,
  DatePicker,
  Typography,
  Select,
  Table,
  InputNumber,
  message,
  Button,
  Popconfirm,
} from "antd";

import moment from "moment";
import "./form.less";
import { platformApi } from "../../../../../api";
import { LeftOutlined } from "@ant-design/icons";
import WrappedVehiclePurchaseForm from "./VehicleDetails";
import { useBranch } from "../../../../../ContextAPI/branch";
import { useHistory } from "react-router-dom";
const { Item } = Form;

const { Text, Title } = Typography;

const VPIModal = (props) => {
  const history = useHistory();
  const { form, open, close, editData, editable: isEditable, modify, deleteAccess } = props;
  const { selectBranch } = useBranch();
  const [branch, setBranch] = useState({ id: "", name: "" });
  const [loading, setLoading] = useState(false);
  const [editable, setEditable] = useState(isEditable);

  useEffect(() => {
    setEditable(isEditable);
  }, [isEditable]);
  const [openVehicle, setOpenVehicle] = useState(false);
  const [invoiceDate, setInvoiceDate] = useState();
  const [purchaseInvoiceNo, setPurchaseInvoice] = useState(props.id);
  const [challan, setChallan] = useState({});
  const [challanData, setChallanData] = useState({
    date: moment(new Date()),
    challanDate: moment(Date.now()),
    id: null,
  });
  const [vehicle, setVehicle] = useState([]);
  const [vehicleDetail, setVehicleDetail] = useState([]);
  const [deletedVehicle, setDeletedVehicle] = useState([]);
  const [quantity, setQuantity] = useState();
  const [amount, setAmt] = useState();
  const [displayIGST, setDisplayIGST] = useState(false);
  const [editChallanNo, setEditChallan] = useState();
  const [dataSource, setDataSource] = useState([]);
  const [tableData, setTable] = useState([]);
  const [invoiceAmount, setInvoiceAmount] = useState([]);
  const [selected, setSelected] = useState(-1);
  const [suppliers, setSuppliers] = useState([]);
  const [invoiceId, setInvoiceId] = useState();
  const { getFieldDecorator, setFieldsValue, getFieldValue } = form;
  const [supplierInvoiceNoError, setSupplierInvoiceNoError] = useState("");
  const [selectedVehicleIndex, setSelectedVehicleIndex] = useState(null);
  const [editVehicleData, setEditVehicleData] = useState(null);
  const [latestPrices, setLatestPrices] = useState({});


  useEffect(() => {
    const fetchLatestPrices = async () => {
      try {
        const prices = {};
        for (const item of vehicleDetail) {
          const vehicleId = item?.vehicle?.id;
          if (!vehicleId) continue;

          const res = await platformApi.get(`/api/vehiclePrice/latest/${vehicleId}`);
          if (res.data.code === 200 && res.data.response?.data) {

            prices[vehicleId] = res.data.response.data?.[0]?.showroomPrice; // or any field like insurance1plus5ZD, etc.
          }
        }
        setLatestPrices(prices);
      } catch (err) {
        console.error("Error fetching latest prices:", err);
      }
    };

    if (vehicleDetail.length > 0) {
      fetchLatestPrices();
    }
  }, [vehicleDetail]);


  useEffect(() => {
    platformApi.get("/api/vehicleMaster").then((result) => {
      let { data } = result;
      if (data.code === 200) {
        let results = [];
        data.response.data.map((obj) => {
          if (obj.vehicleStatus === "AVAILABLE") results.push(obj);
        });
        // setVehicle(data.response.data);
        setVehicle(results);
      }
    });
  }, []);

  useEffect(() => {
    if (editData?.id && editData.purchaseChallan) {
      const purchaseChallan = editData.purchaseChallan;
      setInvoiceId(editData.id);
      setQuantity(editData.quantity);
      setAmt(editData.amount);
      setVehicleDetail((prevData) => [
        ...prevData,
        ...purchaseChallan.vehicleDetail,
      ]);
      form.setFieldsValue({
        supplier: purchaseChallan.supplier.id,
        invoiceDate: moment(editData.invoiceDate),
        invoiceNo: editData.invoiceNo,
        others: editData.others,
        roundOff: editData.roundOff,
        netAmount: editData.netAmount,
        grossTotal: editData.grossTotal,
        supplierInvoiceNo: purchaseChallan.supplierChallanNo,
      });
      setChallanData({
        id: purchaseChallan.id,
        challanNo: purchaseChallan.challanNo,
        supplierChallanNo: purchaseChallan.supplierChallanNo,
        supplier: purchaseChallan.supplier.id,
        location: purchaseChallan.branch.id,
        date:
          purchaseChallan.date === null
            ? moment(Date.now())
            : moment(purchaseChallan.date),
        challanDate: moment(purchaseChallan.challanDate),
      });
      setPurchaseInvoice(editData.invoiceNo);
      setEditChallan(purchaseChallan.id);
      setInvoiceDate(editData.invoiceDate);
    } else {
      setFieldsValue({
        invoiceDate: moment(new Date()),
      });
      platformApi.get("api/supplier").then((result) => {
        let { data } = result;
        if (data.code === 200) {
          let { response } = data;
          if (response.code === 200) {
            let supplier = response.data.filter(
              (obj) =>
                obj.supplierType.includes("Vehicles") && obj.status === "ACTIVE"
            );
            setSuppliers(supplier);
            if (!data) setFieldsValue({ supplier: supplier[0].id });
          }
        }
      });
    }
    if (editData?.purchaseChallan?.branch) {
      setBranch(editData.purchaseChallan.branch);
    } else {
      setBranch(selectBranch[0]);
    }
  }, [editData]);



  useEffect(() => {
    setDataSource([]);
    setInvoiceAmount([]);
  }, [close]);

  useEffect(() => {
    if (open) {
      form.setFieldsValue({
        invoiceDate: moment(new Date()),
      });
      setTable(props.tableData);
      platformApi.get("/api/user/currentUser").then((result) => {
        let { data } = result;
        if (data.code === 200) {
          let { response } = data;
          if (response.code === 200) {
            setBranch(response.data.profile.branch[0]);
          }
        }
      });

      platformApi.get("/api/purchaseChallan/").then((res) => {
        let result = [];
        let { data } = res;
        if (data.code === 200) {
          let { response } = data;
          response.data.map((resp) => {
            if (
              props.tableData.findIndex(
                (obj) => obj.purchaseChallan.id === resp.id
              ) === -1
            ) {
              let obj = {
                id: resp.id,
                name: resp.challanNo,
                SupplierinvoiceNo: resp.supplierChallanNo,
                supplier: resp.supplier,
                location: resp.branch,
                vehicle: resp.vehicleDetail,
              };
              result.push(obj);
            }
          });
          setChallan(result);
        } else {
          message.error("Couldn't fetch id");
        }
      });

      platformApi.get("/api/vehicleMaster").then((result) => {
        let { data } = result;
        if (data.code === 200) {
          setVehicle(data.response.data);
        }
      });

      form.setFieldsValue({ invoiceNo: props.id });
    }
  }, [open]);

  const handlePriceChange = (value, chassis) => {
    let grossTotal = 0;
    const data = [...dataSource];
    for (const index in data) {
      if (data[index].chassisNo === chassis) {
        data[index]["price"] = parseFloat(value) || 0;
        data[index]["amount"] = roundOf(
          data[index]["quantity"] * parseFloat(value)
        );
      }
      grossTotal += data[index]["amount"];
    }
    setDataSource(data);
    setAmt(grossTotal);
    // GST calculation (exclusive)
    const cess = form.getFieldValue("cess") || 0;
    const others = form.getFieldValue("others") || 0;
    const roundOff = form.getFieldValue("roundOff") || 0;
    const gstSummary = calculateGSTSummary(data, cess, others, roundOff);
    form.setFieldsValue({
      grossTotal: gstSummary.grossTotal,
      cgst: gstSummary.totalCGST.toFixed(2),
      sgst: gstSummary.totalSGST.toFixed(2),
      netAmount: gstSummary.netAmount.toFixed(2),
    });
  };

  const deleteVehicleData = (record) => {
    const chassis = record.chassisNo;
    const updatedDataSource = [];
    const deletedVehicleDetail = [];
    const updatedVehicleDetail = [];
    for (const item of dataSource) {
      if (item.chassisNo !== chassis) {
        updatedDataSource.push(item);
      }
    }

    for (const item of vehicleDetail) {
      if (item.chassisNo === chassis) {
        deletedVehicleDetail.push(item);
      } else {
        updatedVehicleDetail.push(item);
      }
    }

    setDataSource(updatedDataSource);
    setDeletedVehicle(prev => [...prev, ...deletedVehicleDetail]);
    setVehicleDetail(updatedVehicleDetail);
  };

  const handleModifyVehicle = (record, index) => {
    setSelectedVehicleIndex(index);
    setEditVehicleData(record);
    setOpenVehicle(true);
  };

  const handleSaveEditedVehicle = (editedVehicle) => {
    // Replace the vehicle at selectedVehicleIndex in vehicleDetail and dataSource
    const updatedVehicleDetail = [...vehicleDetail];
    const updatedDataSource = [...dataSource];
    updatedVehicleDetail[selectedVehicleIndex] = {
      ...updatedVehicleDetail[selectedVehicleIndex],
      ...editedVehicle,
    };
    updatedDataSource[selectedVehicleIndex] = {
      ...updatedDataSource[selectedVehicleIndex],
      ...editedVehicle,
    };
    setVehicleDetail(updatedVehicleDetail);
    setDataSource(updatedDataSource);
    setOpenVehicle(false);
    setSelectedVehicleIndex(null);
    setEditVehicleData(null);
  };

  const column = [
    {
      title: "S.NO",
      key: "index",
      width: 60,
      render: (text, record, index) => <span>{index + 1}</span>,
    },
    {
      title: "Model Code",
      dataIndex: "modelCode",
      key: "modelCode",
      width: 110,
      render: (record) => <span>{record}</span>
    },
    {
      title: "Model Name",
      dataIndex: "modelName",
      key: "modelName",
      width: 130,
      render: (record) => <span>{record}</span>
    },
    {
      title: "Vehicle Color",
      dataIndex: "modelColor",
      key: "modelColor",
      width: 130,
      render: (record) => <span>{record}</span>,
    },
    {
      title: "Chassis Number",
      dataIndex: "chassisNo",
      key: "chassisNo",
      width: 195,
      render: (record) => <span>{record}</span>,
    },
    {
      title: "Engine Number",
      dataIndex: "engineNo",
      key: "engineNo",
      width: 140,
      render: (record) => <span>{record ? record.toUpperCase() : ""}</span>,
    },
    {
      title: "GST",
      dataIndex: "igst",
      key: "igst",
      width: 70,
      render: (record) => <span>{record}</span>,
    },
    {
      title: "Price",
      key: "price",
      width: 170,
      render: (record) => (
        <Input
          min={0}
          type="number"
          step="0.01"
          addonBefore="&#8377;"
          key="price"
          disabled={!editable}
          value={record.price || record.amount || ""}
          onChange={(event) => {
            handlePriceChange(
              parseFloat(event.target.value) || 0,
              record.chassisNo
            );
          }}
          onWheel={(event) => event.currentTarget.blur()}
          placeholder={
            latestPrices[record.vehicle?.id] || record.priceZ?.price || "-"
          }
        />
      ),
    },
    {
      title: "Action",
      key: "modelCode",
      width: 130,
      render: (record, row, index) => (
        editable ? (
          <div style={{ display: "flex", gap: 8 }}>
            <span
              className="linkylink"
              style={{ marginRight: 8, color: "#1890ff", cursor: "pointer" }}
              onClick={() => handleModifyVehicle(record, index)}
            >
              Modify
            </span>
            {deleteAccess && (
              <Popconfirm
                title="Do you want to delete SSI?"
                okText="Yes"
                cancelText="No"
                onCancel={(event) => {
                  event.stopPropagation();
                }}
                disabled={!editable}
                onConfirm={(event) => {
                  event.stopPropagation();
                  deleteVehicleData(record);
                }}
              >
                <span
                  className="linkylink"
                  onClick={(event) => event.stopPropagation()}
                >
                  Delete
                </span>
              </Popconfirm>
            )}
          </div>
        ) : null
      ),
    },
  ];

  const roundOf = (number) => {
    if (number == null) return number;
    const roundedNumber = parseFloat(number).toFixed(2);
    return parseFloat(roundedNumber);
  };

  const handleModify = () => {
    setEditable(true);
  };

  const handleSubmit = () => {
    if (vehicleDetail.length < 1)
      return message.error("Select at least one vehicle");
    form.validateFields((validationError) => {
      if (validationError === null) {
        setLoading(true);
        const invoiceNo = purchaseInvoiceNo || props.id;
        const invoiceDate = form.getFieldValue("invoiceDate");
        const purchaseChallan =
          editChallanNo || form.getFieldValue("challanNo");
        const grossTotal = parseFloat(form.getFieldValue("grossTotal")) || 0;
        const others = parseFloat(form.getFieldValue("others")) || 0;
        const netAmount = parseFloat(form.getFieldValue("netAmount")) || 0;
        const roundOff = parseFloat(form.getFieldValue("roundOff")) || 0;
        const supplier = form.getFieldValue("supplier");
        const supplierInvoiceNo = form.getFieldValue("supplierInvoiceNo");
        let results = [];
        for (const index in dataSource) {
          vehicleDetail[index].invoiceAmount = dataSource[index].amount;
          let newObj = {
            id: dataSource[index].priceZ.vehicleId,
            amount: dataSource[index].amount,
          };
          results.push(newObj);
        }
        setInvoiceAmount(results);

        let invoiceAmount = results;
        const vpi = {
          id: invoiceId,
          invoiceNo,
          invoiceDate,
          purchaseChallan,
          grossTotal,
          others,
          quantity,
          amount: netAmount,
          netAmount: netAmount,
          roundOff,
          invoiceAmount,
          branch: branch.id,
          vehicleDetail,
          deletedVehicle,
          challan,
          challanData,
          supplier,
          supplierInvoiceNo,
        };
        props.emitData(vpi);
        setLoading(false);
        dataSource.length = 0;
        props.close();
        // clearFields();
      }
    });
  };

  const handleCancel = () => {
    form.resetFields();
    history.push("/autoadmin/vehicle_purchase_invoice");
  };

  const emitVehicleData = (data) => {
    // setChallan(data)
    handleChallanChange(data);
  };

  const clearFields = () => {
    form.resetFields();
  };

  const onChange = (date, dateString) => {
    setInvoiceDate(dateString);
  };

  const handleChallanChange = (selectedVehicles) => {
    const updatedVehicles = selectedVehicles;
    for (const index in updatedVehicles) {
      updatedVehicles[index].invoiceAmount =
        vehicle[
          vehicle.findIndex(
            (obj) => obj.modelCode === updatedVehicles[index].vehicle.modelCode
          )
        ]?.price[0]?.showroomPrice || null;
    }
    setVehicleDetail((prevData) => [...prevData, ...updatedVehicles]);
  };

  const stripLeadingZeros = (val) => {
    if (val === null || val === undefined) return "";
    let str = val.toString().replace(/[^0-9.-]/g, '');
    let isNegative = str.startsWith("-");
    if (isNegative) {
      str = str.substring(1);
    }
    str = str.replace(/^0+(?=\d)/, '');
    return isNegative ? "-" + str : str;
  };

  const othersChange = (e) => {
    const valuez = e.target.value;
    if (valuez === "-") return;
    const stripped = stripLeadingZeros(valuez);
    form.setFieldsValue({
      others: stripped,
    });
    const value = Number(stripped) || 0;
    const roundOff = Number(form.getFieldValue("roundOff")) || 0;
    const cess = Number(form.getFieldValue("cess")) || 0;
    const gstSummary = calculateGSTSummary(dataSource, cess, value, roundOff);
    form.setFieldsValue({
      netAmount: gstSummary.netAmount.toFixed(2),
    });
  };

  const roundOffChange = (e) => {
    const valuez = e.target.value;
    if (valuez === "-") return;
    const stripped = stripLeadingZeros(valuez);
    form.setFieldsValue({
      roundOff: stripped,
    });
    const value = Number(stripped) || 0;
    const others = Number(form.getFieldValue("others")) || 0;
    const cess = Number(form.getFieldValue("cess")) || 0;
    const gstSummary = calculateGSTSummary(dataSource, cess, others, value);
    form.setFieldsValue({
      netAmount: gstSummary.netAmount.toFixed(2),
    });
  };

  // GST calculation (exclusive)
  function calculateGSTSummary(dataSource, cess = 0, others = 0, roundOff = 0) {
    const gstGroups = {};
    let totalCGST = 0;
    let totalSGST = 0;
    let totalIGST = 0;
    let grossTotal = 0;

    dataSource.forEach((item) => {
      const gstPercent = parseFloat(item.igst) || 0;
      const price = parseFloat(item.amount) || 0;
      grossTotal += price;
      if (!gstPercent || !price) return;
      // Exclusive GST calculation
      const cgstAmountItem = (price * (gstPercent / 2)) / 100;
      const sgstAmountItem = (price * (gstPercent / 2)) / 100;
      const igstAmountItem = (price * gstPercent) / 100;
      totalCGST += cgstAmountItem;
      totalSGST += sgstAmountItem;
      totalIGST += igstAmountItem;
      if (!gstGroups[gstPercent]) {
        gstGroups[gstPercent] = {
          gstPercent,
          cgstPercent: gstPercent / 2,
          sgstPercent: gstPercent / 2,
          taxableValue: 0,
          cgstAmount: 0,
          sgstAmount: 0,
          igstAmount: 0,
        };
      }
      gstGroups[gstPercent].taxableValue += price;
      gstGroups[gstPercent].cgstAmount += cgstAmountItem;
      gstGroups[gstPercent].sgstAmount += sgstAmountItem;
      gstGroups[gstPercent].igstAmount += igstAmountItem;
    });

    grossTotal = parseFloat(grossTotal.toFixed(2));
    const totalGST = totalCGST + totalSGST; // or totalIGST if IGST is used
    let netAmount =
      grossTotal +
      totalGST +
      (parseFloat(cess) || 0) +
      (parseFloat(others) || 0) +
      (parseFloat(roundOff) || 0);

    return {
      gstGroups,
      totalCGST,
      totalSGST,
      totalIGST,
      grossTotal,
      totalGST,
      netAmount,
      roundedNetAmount: netAmount,
      roundOff,
    };
  }

  // Call GST calculation on vehicle/vehicleDetail change
  useEffect(() => {
    if (vehicleDetail) {
      let results = [];
      let index = {};
      vehicleDetail.forEach((point) => {
        if (!point.vehicle) return;
        let key = "" + point.vehicle.modelCode + "||" + point.vehicle.modelName;
        let newEntry = {
          modelCode: point.vehicle.modelCode,
          modelName: point.vehicle.modelName,
          modelColor: point.color?.color,
          hsnCode: point.vehicle?.hsn?.code,
          chassisNo: point.chassisNo,
          engineNo: point.engineNo,
          igst: point.vehicle?.hsn?.igst,
          quantity: 1,
          amount: 0,
          price: point.invoiceAmount,
          priceZ: {
            price: point.invoiceAmount,
            code: point.vehicle.modelCode,
            challanId: editData?.purchaseChallan?.id || "",
            vehicleId: point.id,
          },
          manufacturer: point.vehicle?.manufacturer,
          batteryNo: point.batteryNo,
          warrantyBookNo: point.warrantyBookNo,
          keyNo: point.keyNo,
          vehicle: point.vehicle,
          manMonthYear: point.manMonthYear,
          color: point.color
        };
        index[key] = newEntry;
        results.push(newEntry);
      });
      results.forEach((obj) => {
        obj.price /= obj.quantity;
        obj.amount = obj.price * obj.quantity;
      });
      setDataSource(results);
      setQuantity(results.reduce((sum, obj) => sum + obj.quantity, 0));
      setAmt(results.reduce((sum, obj) => sum + obj.amount, 0));
      // GST calculation (exclusive)
      const cess = form.getFieldValue("cess") || 0;
      const others = form.getFieldValue("others") || 0;
      const roundOff = form.getFieldValue("roundOff") || 0;
      const gstSummary = calculateGSTSummary(results, cess, others, roundOff);
      form.setFieldsValue({
        grossTotal: gstSummary.grossTotal,
        cgst: gstSummary.totalCGST.toFixed(2),
        sgst: gstSummary.totalSGST.toFixed(2),
        netAmount: gstSummary.netAmount.toFixed(2),
        roundOff: gstSummary.roundOff,
      });
    }
  }, [vehicle, vehicleDetail]);

  const renderGSTSummaryForm = () => {
    const cess = Number(form.getFieldValue("cess")) || 0;
    const others = Number(form.getFieldValue("others")) || 0;
    const roundOff = Number(form.getFieldValue("roundOff")) || 0;
    const gstSummary = calculateGSTSummary(dataSource, cess, others, roundOff);
    return (
      <div
        className="gst-table"
        style={{
          border: "1px solid #222",
          borderRadius: 4,
          padding: 8,
          maxWidth: 320,
          margin: "20px 0",
          background: "#f8fafc",
        }}
      >
        <div
          style={{
            textAlign: "center",
            fontWeight: 600,
            borderBottom: "1px solid #222",
            marginBottom: 8,
          }}
        >
          GST Data
        </div>
        {Object.values(gstSummary.gstGroups).map((g, i) => (
          <React.Fragment key={i}>
            <Form.Item
              className="form-element"
              style={{ marginBottom: 4, display: "flex", alignItems: "center" }}
              label={<span style={{ minWidth: 60 }}>CGST:</span>}
            >
              <span style={{ marginRight: 8 }}>{g.cgstPercent}%</span>
              <Input
                style={{ width: 120 }}
                disabled
                value={g.cgstAmount.toFixed(2)}
              />
            </Form.Item>
            <Form.Item
              className="form-element"
              style={{ marginBottom: 8, display: "flex", alignItems: "center" }}
              label={<span style={{ minWidth: 60 }}>SGST:</span>}
            >
              <span style={{ marginRight: 8 }}>{g.sgstPercent}%</span>
              <Input
                style={{ width: 120 }}
                disabled
                value={g.sgstAmount.toFixed(2)}
              />
            </Form.Item>
          </React.Fragment>
        ))}
      </div>
    );
  };

  // Prepare branch options for the dropdown
  let branchOptions = selectBranch ? [...selectBranch] : [];
  if (
    editData?.purchaseChallan?.branch &&
    !branchOptions.some((b) => b.id === editData.purchaseChallan.branch.id)
  ) {
    branchOptions = [editData.purchaseChallan.branch, ...branchOptions];
  }

  return (
    <Form>
      <Row type="flex" justify="space-between">
        <Row type="flex" justify="space-between">
          <Col span={10}>
            <Item
              label={<Text> Internal VPI Number.</Text>}
              colon={false}
              required={false}
            >
              {getFieldDecorator("invoiceNo", {
                rules: [
                  {
                    // required: true,
                    message: "Enter Internal Vehicle Purchase Invoice",
                  },
                ],
              })(
                <Input
                  disabled={true}
                  placeholder={props.id}
                  // value={props.id}
                  style={{ width: "27.5rem" }}
                />
              )}
            </Item>
          </Col>
          <Col span={11}></Col>
        </Row>
        <Col span={10}>
          <Item label="Invoice Date" colon={false}>
            {getFieldDecorator("invoiceDate", {
              rules: [{ required: true, message: "Enter Invoice Date" }],
            })(
              <DatePicker
                disabled={!editable}
                allowClear={true}
                disabledDate={(moment) => moment._d > Date.now()}
                format="DD-MMM-YYYY"
                style={{ width: "100%" }}
              />
            )}
          </Item>
        </Col>
      </Row>
      <Row type="flex" justify="space-between">
        <Col span={10}>
          <Form.Item
            className="purchase-form-element"
            label="Location"
            name="branch"
            required
          >
            <Select
              disabled={!editable}
              dropdownStyle={{
                overflowY: "auto",
                overflowX: "hidden",
              }}
              value={branch.id}
              onChange={(branchId) => {
                const selectedBranch = branchOptions.find(
                  (b) => b.id === branchId
                );
                setBranch(selectedBranch || { id: branchId, name: branchId });
              }}
              showAction={["click", "focus"]}
              showSearch
              placeholder="Branch"
              filterOption={null}
            >
              {branchOptions.map((eachBranch) => (
                <Select.Option key={eachBranch.id} value={eachBranch.id}>
                  {eachBranch.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row type="flex" justify="space-between">
        <Col span={10}>
          <Item colon={false} label="Supplier">
            {getFieldDecorator("supplier", {
              rules: [{ required: true, message: "Select Supplier" }],
            })(
              <Select
                disabled={!editable}
                placeholder="Select the supplier"
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.props.children.toLowerCase().includes(input.toLowerCase())
                }
              >
                {suppliers.map((supplier) => (
                  <Select.Option key={supplier.id} value={supplier.id}>
                    {supplier.name}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Item>
        </Col>
        <Col span={10}>
          <Item
            label={<Text>Supplier Invoice Number.</Text>}
            colon={false}
            required={false}
          >
            {getFieldDecorator("supplierInvoiceNo", {
              rules: [
                {
                  required: true,
                  message: "Enter Supplier Invoice Number.",
                },
                {
                  validator: async (rule, value, callback) => {
                    const supplierId = form.getFieldValue("supplier");
                    if (!value || !supplierId) {
                      callback();
                      return;
                    }
                    const res = await platformApi.post(
                      "/api/purchaseInvoice/checkDuplicateInvoiceNo",
                      { invoiceNo: value, supplierId }
                    );
                    let { data } = res;
                    if (editData?.invoiceNo) {
                      if (
                        data.duplicate &&
                        data?.data?.invoiceNo != editData.invoiceNo
                      ) {
                        callback("Invoice Number already exists");
                      } else {
                        callback();
                      }
                    } else {
                      if (data.duplicate) {
                        callback("Invoice Number already exists");
                      } else {
                        callback();
                      }
                    }
                  },
                },
              ],
            })(
              <Input
                disabled={!editable || !form.getFieldValue("supplier")}
                placeholder="Supplier Invoice Number"
                onKeyUp={(e) => {
                  // Allow alphanumeric, hyphens, dots, forward slashes, and spaces
                  const value = e.target.value.replace(/[^a-zA-Z0-9\-./\s]/g, '');
                  form.setFieldsValue({
                    supplierInvoiceNo: value,
                  });
                }}
                onInput={(event) => {
                  // Filter out special characters in real-time
                  const rawValue = event.target.value;
                  const filteredValue = rawValue.replace(/[^a-zA-Z0-9\-./\s]/g, '');
                  if (filteredValue !== rawValue) {
                    event.target.value = filteredValue;
                    form.setFieldsValue({
                      supplierInvoiceNo: filteredValue,
                    });
                  }
                }}
              />
            )}
          </Item>
        </Col>
      </Row>
      <div>
        <strong>Add vehicle details</strong>
        <Button
          style={{ margin: "0 2rem" }}
          type="primary"
          onClick={() => {
            setOpenVehicle(true);
            setEditable(editable);
          }}
          disabled={!editable}
        >
          Add
        </Button>
      </div>
      <br />
      <Table
        rowKey={(record) => record.id}
        pagination={false}
        columns={column}
        style={{ cursor: "pointer" }}
        tableLayout="fixed"
        dataSource={dataSource}
      />
      <Row type="flex" justify="space-between" align="middle">
        <Col span={6} style={{ display: "flex", alignItems: "center" }}>
          <Item label={<Text>Gross Total</Text>} colon={false} required={false}>
            {getFieldDecorator("grossTotal")(
              <Input
                addonBefore="&#8377;"
                disabled={true}
                placeholder="Gross Total"
              />
            )}
          </Item>
        </Col>
        <Col
          span={12}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{ display: "flex", justifyContent: "center", width: "100%" }}
          >
            {renderGSTSummaryForm()}
          </div>
        </Col>
        <Col
          span={6}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <Item label={<Text>Others</Text>} colon={false} required={false}>
            {getFieldDecorator("others", {
              initialValue: 0,
              getValueFromEvent: (e) => stripLeadingZeros(e.target.value),
            })(
              <Input
                addonBefore="&#8377;"
                disabled={!editable}
                placeholder="Others"
                onChange={othersChange}
              />
            )}
          </Item>
        </Col>
      </Row>
      <Row type="flex" justify="space-between">

        <Col span={4}>
          <Item label={<Text>Cess</Text>} colon={false} required={false}>
            {getFieldDecorator(
              "cess"

            )(<Input disabled={true} placeholder="Cess" />)}
          </Item>
        </Col>
        <Col span={4}>
          <Item label={<Text>Round Off</Text>} colon={false} required={false}>
            {getFieldDecorator(
              "roundOff",
              {
                initialValue: 0,
                getValueFromEvent: (e) => stripLeadingZeros(e.target.value),
              }
            )(
              <Input
                addonBefore="&#8377;"
                disabled={!editable}
                onChange={roundOffChange}
                placeholder="Round Off"
              />
            )}
          </Item>
        </Col>
        <Col span={4}>
          <Item label={<Text>Net Amount</Text>} colon={false} required={false}>
            {getFieldDecorator(
              "netAmount"

            )(
              <Input
                addonBefore="&#8377;"
                disabled={true}
                placeholder="Net Amount"
              />
            )}
          </Item>
        </Col>
      </Row>
      <div style={{ float: "right" }}>
        <Button
          style={{ marginRight: "1rem" }}
          size="large"
          onClick={() => handleCancel()}
        >
          Cancel
        </Button>
        {(!editable && !modify) ? null : (
          <Button
            type="primary"
            size="large"
            onClick={editable ? () => handleSubmit() : () => handleModify()}
          >
            {editable ? "Save" : "Modify"}
          </Button>
        )}
      </div>
      {openVehicle && (
        <WrappedVehiclePurchaseForm
          open={openVehicle}
          close={() => {
            setOpenVehicle(false);
            setSelectedVehicleIndex(null);
            setEditVehicleData(null);
            setSelected(null);
          }}
          emitData={
            selectedVehicleIndex !== null
              ? (data) => handleSaveEditedVehicle(data[0])
              : emitVehicleData
          }
          data={editVehicleData}
          deleteAccess={deleteAccess}
        />
      )}
    </Form>
  );
};

const VehiclePurchaseInvoiceForm = Form.create({ name: "normal_login" })(
  VPIModal
);

export default VehiclePurchaseInvoiceForm;
